export default "__VITE_ASSET__CquiTM_u__"